<div class="modal-wrapper">
    <div class="modal-head-wrapper" (click)="closeModal()">
        <h3 class="modal-heading">Confirm</h3>
        <i class="fa fa-times modal-close"></i>
    </div>
    <div class="modal-body">
        <p #message>{{ modalMessage }}</p>
        <button class="cancel-btn" (click)="closeModal()">Cancel</button>
        <button class="ok-btn" (click)="okClick()">Ok</button>
    </div>
</div>
